import React, { FC } from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@mui/material';
import { IAppState } from '../../../state/reducers';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import Settings from './ExportTemplateSettings/component';
import { toggleExportTemplateSettings, clearExportTemplateSettings } from '../../../state/exchange/exporttemplateSettings';

const ExchangeExportTemplateSettingsDialog: FC<IProps> = (props: IProps) => {
  const {
    isOpen,
    onClose,
    onExited,
  } = props;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="md"
    >
      <Settings />
    </Dialog>
  );
};

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.exchange.exporttemplatesettings.isOpen,
});

const mapDispatchToProps: IDispatchProps = {
  onClose: toggleExportTemplateSettings,
  onExited: clearExportTemplateSettings,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExchangeExportTemplateSettingsDialog);
